const getters = {
  userInfo: (state) => state.user.userInfo,
  examList: (state) => state.exam.examList,
  currentExamInfo: (state) => state.exam.currentExamInfo,
  currentExamId: (state) => state.exam.currentExamId,
  unreadNotifyCount: (state) => state.notify.unreadNotifyCount,
};
export default getters;
